import { c as _c } from "react/compiler-runtime";
import { classNames, FlexColumn, formatAddress, Input, Spinner, TextLabel, UnstyledButton } from "@opensea/ui-kit";
import { Check, ContentPaste } from "@opensea/ui-kit/icons";
import { useCallback } from "react";
import { useTranslations } from "use-intl";
export function WalletAddressInput(t0) {
  const $ = _c(50);
  let className;
  let disabled;
  let ensName;
  let imageUrl;
  let isResolving;
  let placeholder;
  let props;
  let resolvedAddress;
  let setValue;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      setValue,
      placeholder,
      className,
      size: t1,
      ensName,
      imageUrl,
      isResolving,
      resolvedAddress,
      disabled,
      withResetButton: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = disabled;
    $[3] = ensName;
    $[4] = imageUrl;
    $[5] = isResolving;
    $[6] = placeholder;
    $[7] = props;
    $[8] = resolvedAddress;
    $[9] = setValue;
    $[10] = t1;
    $[11] = t2;
  } else {
    className = $[1];
    disabled = $[2];
    ensName = $[3];
    imageUrl = $[4];
    isResolving = $[5];
    placeholder = $[6];
    props = $[7];
    resolvedAddress = $[8];
    setValue = $[9];
    t1 = $[10];
    t2 = $[11];
  }
  const size = t1 === undefined ? "md" : t1;
  const withResetButton = t2 === undefined ? true : t2;
  const t = useTranslations("wallet.WalletAddressInput");
  const displayValue = resolvedAddress ? ensName ? `${ensName} (${formatAddress(resolvedAddress)})` : resolvedAddress : undefined;
  let t3;
  if ($[12] !== setValue) {
    t3 = async () => {
      const text = await navigator.clipboard.readText();
      setValue(text);
    };
    $[12] = setValue;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const pasteFromClipboard = t3;
  let t4;
  if ($[14] !== imageUrl || $[15] !== size) {
    t4 = () => {
      if (imageUrl) {
        return <img alt="" className={classNames("rounded-full", {
          "size-6": size === "md",
          "size-4": size === "sm"
        })} src={imageUrl} />;
      }
    };
    $[14] = imageUrl;
    $[15] = size;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  const getLeftIcon = t4;
  let t5;
  if ($[17] !== isResolving || $[18] !== pasteFromClipboard || $[19] !== resolvedAddress || $[20] !== size) {
    t5 = () => {
      if (isResolving) {
        return <Spinner size={size === "md" ? "sm" : "xs"} />;
      }
      if (resolvedAddress) {
        return <Check className="text-success-1" size={size === "md" ? 24 : 16} />;
      }
      return <UnstyledButton onClick={pasteFromClipboard}><ContentPaste className="text-text-secondary" size={size === "md" ? 24 : 16} /></UnstyledButton>;
    };
    $[17] = isResolving;
    $[18] = pasteFromClipboard;
    $[19] = resolvedAddress;
    $[20] = size;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  const getRightIcon = t5;
  const t6 = size === "md";
  const t7 = size === "sm";
  const t8 = resolvedAddress !== undefined;
  let t9;
  if ($[22] !== className || $[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
    t9 = classNames("bg-bg-additional-1", {
      "h-14": t6,
      "h-8": t7,
      "opacity-100": t8
    }, className);
    $[22] = className;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  const t10 = disabled || Boolean(resolvedAddress);
  let t11;
  if ($[27] !== getRightIcon) {
    t11 = getRightIcon();
    $[27] = getRightIcon;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== placeholder || $[30] !== t) {
    t12 = placeholder || t("placeholder");
    $[29] = placeholder;
    $[30] = t;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== getLeftIcon) {
    t13 = getLeftIcon();
    $[32] = getLeftIcon;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== displayValue || $[35] !== props || $[36] !== t10 || $[37] !== t11 || $[38] !== t12 || $[39] !== t13 || $[40] !== t9) {
    t14 = <Input {...props} autoComplete="off" className={t9} disabled={t10} endEnhancer={t11} placeholder={t12} startEnhancer={t13} value={displayValue} />;
    $[34] = displayValue;
    $[35] = props;
    $[36] = t10;
    $[37] = t11;
    $[38] = t12;
    $[39] = t13;
    $[40] = t9;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  let t15;
  if ($[42] !== resolvedAddress || $[43] !== setValue || $[44] !== t || $[45] !== withResetButton) {
    t15 = withResetButton && Boolean(resolvedAddress) && <UnstyledButton className="opacity-75 hover:underline hover:opacity-100" onClick={() => setValue("")}><TextLabel>{t("reset")}</TextLabel></UnstyledButton>;
    $[42] = resolvedAddress;
    $[43] = setValue;
    $[44] = t;
    $[45] = withResetButton;
    $[46] = t15;
  } else {
    t15 = $[46];
  }
  let t16;
  if ($[47] !== t14 || $[48] !== t15) {
    t16 = <FlexColumn className="items-end gap-2.5">{t14}{t15}</FlexColumn>;
    $[47] = t14;
    $[48] = t15;
    $[49] = t16;
  } else {
    t16 = $[49];
  }
  return t16;
}